<lib-reading-group-book-info
  [bookInfo]="bookInfo"
></lib-reading-group-book-info>
<form [formGroup]="_groupFormGroup" (ngSubmit)="_onSubmit()">
  <lib-reading-group-form-field
    label="그룹책 별명"
    [required]="true"
    [isNickname]="true"
  >
    <input
      class="name-input"
      formControlName="name"
      placeholder="그룹책의 별명을 지어주세요."
    />
    <lib-reading-group-form-field-hint
      [isValid]="_groupFormGroup.get('name')!.valid"
      [isError]="
        _groupFormGroup.get('name')!.touched &&
        _groupFormGroup.get('name')!.invalid
      "
      >5 - 30자 이내
    </lib-reading-group-form-field-hint>
  </lib-reading-group-form-field>

  <lib-reading-group-form-field label="그룹책 유형" [required]="true">
    <div class="radio-group">
      <sui-radio-button>
        공개 그룹
        <input
          type="radio"
          formControlName="type"
          name="type"
          [value]="'public'"
        />
      </sui-radio-button>
      <sui-radio-button>
        비공개 그룹
        <input
          type="radio"
          formControlName="type"
          name="type"
          [value]="'private'"
        />
      </sui-radio-button>
      <div class="note-checkbox" *ngIf="_isPrivateGroup">
        <sui-checkbox>
          <input type="checkbox" formControlName="is_hidden" id="is_hidden" />
        </sui-checkbox>
        <label for="is_hidden" class="note" style="cursor: pointer">
          숨김
          <span class="description"
            >(숨김 처리시 사이트에 노출되지 않습니다)</span
          >
        </label>
      </div>
    </div>
  </lib-reading-group-form-field>

  <lib-reading-group-form-field
    label="그룹책 멤버 수"
    [required]="true"
    *ngIf="_isPrivateGroup"
  >
    <input
      type="number"
      formControlName="max_member_count"
      placeholder="최대 {{
        _isPrivateGroup ? '300' : '100'
      }}명까지 설정할 수 있습니다."
    />
    <lib-reading-group-form-field-hint
      [isValid]="_groupFormGroup.get('max_member_count')!.valid"
      [isError]="
        _groupFormGroup.get('max_member_count')!.touched &&
        _groupFormGroup.get('max_member_count')!.invalid
      "
    >
      최소 2명 - 최대 {{ _isPrivateGroup ? '300' : '100' }}명 사이
    </lib-reading-group-form-field-hint>
  </lib-reading-group-form-field>

  <lib-reading-group-form-field
    *ngIf="_isPrivateGroup"
    label="그룹책 비밀번호"
    [required]="true"
  >
    <input
      maxlength="4"
      formControlName="passcode"
      placeholder="그룹책 비밀번호를 입력해주세요."
    />
    <lib-reading-group-form-field-hint
      [isValid]="_groupFormGroup.get('passcode')!.valid"
      [isError]="
        _groupFormGroup.get('passcode')!.touched &&
        _groupFormGroup.get('passcode')!.invalid
      "
      >숫자 4 자리</lib-reading-group-form-field-hint
    >
  </lib-reading-group-form-field>

  <!-- <lib-reading-group-form-field
    label="그룹숨김"
    [required]="true"
    *ngIf="_isPrivateGroup"
  >
    <div class="note-checkbox">
      <sui-checkbox>
        <input type="checkbox" formControlName="is_hidden" />
      </sui-checkbox>
      <p class="note">
        숨김 시, 해당 그룹이 사이트 내에 노출되지 않으며 숨김 여부는 언제든지
        변경이 가능합니다.<br />
        <span class="description"
          >단, 초대 / 가입된 그룹일 경우 숨김 여부와 상관없이 그룹이
          노출됩니다.</span
        >
      </p>
    </div>
  </lib-reading-group-form-field> -->

  <lib-reading-group-form-field label="그룹책 소개" [required]="true">
    <textarea
      formControlName="description"
      placeholder="그룹책을 소개해 주세요."
    ></textarea>
    <lib-reading-group-form-field-hint
      [isValid]="_groupFormGroup.get('description')!.valid"
      [isError]="
        _groupFormGroup.get('description')!.touched &&
        _groupFormGroup.get('description')!.invalid
      "
      >5 - 200자 이내</lib-reading-group-form-field-hint
    >
    <lib-reading-group-form-field-hint
      ><span [class.is-warning]="_descriptionLength >= 200">{{
        _descriptionLength
      }}</span
      >/200</lib-reading-group-form-field-hint
    >
  </lib-reading-group-form-field>

  <div class="buttons desktop">
    <button
      type="submit"
      varSize="medium40"
      sui-solid-button
      [disabled]="_groupFormGroup.invalid || !isChanged || _isSubmitting"
    >
      {{ initialValue ? '저장하기' : '그룹책 만들기' }}
    </button>
  </div>
  <div class="mobile-buttons" *ngIf="!_isKeyboardVisible">
    <button
      type="submit"
      varSize="large:large:medium40"
      sui-solid-button
      [disabled]="_groupFormGroup.invalid || !isChanged || _isSubmitting"
    >
      {{ initialValue ? '저장하기' : '그룹책 만들기' }}
    </button>
  </div>
</form>
